import { useTranslation } from "react-i18next";
import { TbLogout } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

import { NAMESPACES } from "@/constants/i18next.constants";
import { ROUTES } from "@/constants/routes";
import { useAuthStore } from "@/features/Auth";

import { LogoutButtonStyled } from "./LogoutButton.styles";

function LogoutButton() {
  const { t } = useTranslation(NAMESPACES.COMMON);
  const navigate = useNavigate();

  const logout = useAuthStore(state => state.logout);

  const handleLogout = () => {
    navigate(ROUTES.LOGIN);
    logout();
  };

  return (
    <LogoutButtonStyled variant="text" title={t("logout")} icon={<TbLogout />} onClick={handleLogout} />
  );
}

export default LogoutButton;
